export const constants_proveedores = {
  OBTENER_PROVEEDORES_REQUEST: 'OBTENER_PROVEEDORES_REQUEST',
  OBTENER_PROVEEDORES_FAILURE: 'OBTENER_PROVEEDORES_FAILURE',
  OBTENER_PROVEEDORES_SUCCESS: 'OBTENER_PROVEEDORES_SUCCESS',

  OBTENER_PROVEEDORES_OPTO11_REQUEST: 'OBTENER_PROVEEDORES_OPTO11_REQUEST',
  OBTENER_PROVEEDORES_OPTO11_FAILURE: 'OBTENER_PROVEEDORES_OPTO11_FAILURE',
  OBTENER_PROVEEDORES_OPTO11_SUCCESS: 'OBTENER_PROVEEDORES_OPTO11_SUCCESS',
};
